// extracted by mini-css-extract-plugin
export default {"box":"BookingRequests_box__M3tIU","label":"BookingRequests_label__FIcgi"};